import './banner-site.scss';

/**
 * version    1.0
 * class      <type> (BannerSite)
 * classdesc  Banner site: contains 1 img background, title and description
 */
export class BannerSite {}
